import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/media/images/BlackPakkelabel.png'
import _imports_1 from '@/assets/media/images/WhitePakkelabel.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-afdc3c4c")

_pushScopeId("data-v-afdc3c4c")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-8" }
const _hoisted_3 = { class: "row mb-5" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-header card-p border-0" }
const _hoisted_7 = { class: "card-header-title mb-0 p-0 fs-5" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_9 = {
  key: 0,
  class: "fs-6 text-overflow text-overflow-z symbol"
}
const _hoisted_10 = {
  key: 1,
  class: "fs-6 text-overflow text-overflow-z symbol"
}
const _hoisted_11 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_12 = { class: "fs-6 text-overflow text-overflow-z symbol" }
const _hoisted_13 = { style: {"white-space":"nowrap"} }
const _hoisted_14 = {
  style: {"white-space":"nowrap"},
  class: "d-block fs-6"
}
const _hoisted_15 = { class: "row mb-5" }
const _hoisted_16 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-header card-header-title mb-5 card-p fs-5" }
const _hoisted_19 = { class: "row mb-5" }
const _hoisted_20 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_21 = { class: "card" }
const _hoisted_22 = { class: "card-header card-header-title mb-5 card-p fs-5" }
const _hoisted_23 = { class: "address-list card-p" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_28 = { class: "card" }
const _hoisted_29 = { class: "card-header card-header-title mb-5 card-p fs-5" }
const _hoisted_30 = { class: "address-list card-p" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-12" }
const _hoisted_36 = {
  key: 0,
  class: "card mb-5 card-p"
}
const _hoisted_37 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_38 = { class: "d-flex flex-wrap align-items-center justify-content-between" }
const _hoisted_39 = { class: "d-flex flex-wrap align-items-center name-area" }
const _hoisted_40 = { class: "d-block fs-7 fw-300 mt-1" }
const _hoisted_41 = {
  key: 0,
  class: "d-block fs-7 fw-300 mt-2"
}
const _hoisted_42 = {
  key: 1,
  class: "card mb-5 card-p"
}
const _hoisted_43 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_44 = { class: "d-flex flex-wrap align-items-center justify-content-between" }
const _hoisted_45 = { class: "d-flex flex-wrap align-items-center name-area" }
const _hoisted_46 = { class: "d-block fs-7 fw-300 mt-1" }
const _hoisted_47 = {
  key: 2,
  class: "card mb-5 card-p"
}
const _hoisted_48 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_49 = { class: "summary-list" }
const _hoisted_50 = {
  key: 3,
  class: "card mb-5 card-p"
}
const _hoisted_51 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_52 = { class: "summary-list" }
const _hoisted_53 = {
  key: 4,
  class: "card mb-5 card-p"
}
const _hoisted_54 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_55 = {
  key: 0,
  class: "summary-list"
}
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { class: "subscription-title" }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "card mb-5 card-p" }
const _hoisted_60 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_61 = {
  key: 0,
  class: "summary-list"
}
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "card mb-5 card-p" }
const _hoisted_64 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_65 = { class: "summary-list" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = {
  key: 5,
  class: "card mb-5 card-p"
}
const _hoisted_70 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_71 = { class: "col-md-9" }
const _hoisted_72 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  height: "100",
  width: "100"
}, null, -1)
const _hoisted_74 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_75 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  height: "100",
  width: "100"
}, null, -1)
const _hoisted_76 = { class: "card mb-5 card-p" }
const _hoisted_77 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_78 = {
  key: 0,
  class: "summary-list"
}
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { key: 2 }
const _hoisted_82 = { class: "fs-4" }
const _hoisted_83 = { key: 3 }
const _hoisted_84 = {
  key: 6,
  class: "card mb-5 card-p"
}
const _hoisted_85 = { class: "summary-list note-list" }
const _hoisted_86 = { class: "card card-p" }
const _hoisted_87 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_88 = {
  key: 7,
  class: "card card-p bc-error-box mt-5"
}
const _hoisted_89 = { class: "card-header-title mb-5 p-0 fs-5" }
const _hoisted_90 = { class: "bc-error-message" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Table = _resolveComponent("Table")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Select = _resolveComponent("Select")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loader,
      innerLoading: false
    }, null, 8, ["loading"]),
    _createVNode(_component_InnerLoader, { loading: _ctx.sendMailLoader }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("header", _hoisted_6, [
                _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('message.ORDER_PRODUCT')), 1)
              ]),
              _createVNode(_component_Table, {
                columns: _ctx.columns,
                rows: _ctx.orders.order_products,
                padding: 5
              }, {
                "cell-image": _withId(({ row: item }) => [
                  (item?.product?.media.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        (item?.product?.media[0].file_path)
                          ? (_openBlock(), _createBlock("span", _hoisted_9, [
                              _createVNode("img", {
                                src: item?.product?.media[0].file_path
                              }, null, 8, ["src"])
                            ]))
                          : (_openBlock(), _createBlock("span", _hoisted_10, [
                              _createVNode("img", { src: _ctx.defaultImage }, null, 8, ["src"])
                            ]))
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_11, [
                        _createVNode("span", _hoisted_12, [
                          _createVNode("img", { src: _ctx.defaultImage }, null, 8, ["src"])
                        ])
                      ]))
                ]),
                "cell-price": _withId(({ row: item }) => [
                  _createVNode("span", _hoisted_13, _toDisplayString(item?.price_label_without_tax), 1)
                ]),
                "cell-description": _withId(({ row: item }) => [
                  _createTextVNode(_toDisplayString(JSON.parse(item?.product?.description?.name)[_ctx.system_locale]?.name), 1)
                ]),
                "cell-total": _withId(({ row: item }) => [
                  _createVNode("span", _hoisted_14, _toDisplayString(item?.total), 1)
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          (_ctx.orders?.order_status)
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode(_component_InnerLoader, {
                    loading: _ctx.loader,
                    innerLoading: true
                  }, null, 8, ["loading"]),
                  _createVNode("header", _hoisted_18, _toDisplayString(_ctx.$t('message.ORDER_STATUS')), 1),
                  _createVNode(_component_el_steps, {
                    "align-center": "",
                    active: _ctx.orders?.order_status_id == 2 ? 1 : _ctx.orders?.order_status_id == 1 ? 2 : _ctx.orders?.order_status_id == 10 ? 3 : _ctx.orders?.order_status_id == 6 ? 4 : '',
                    "finish-status": "success",
                    class: "card-p order-status-steps"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_step, {
                        title: _ctx.i18n.t('message.ORDER_RECEIVED')
                      }, null, 8, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.i18n.t('message.ORDER_IN_PROGRESS')
                      }, null, 8, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.i18n.t('message.SHIPMENT_IN_PROGRESS')
                      }, null, 8, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.i18n.t('message.ORDER_SHIPPED')
                      }, null, 8, ["title"])
                    ]),
                    _: 1
                  }, 8, ["active"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_19, [
          (_ctx.orders?.order_shipping_address)
            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("header", _hoisted_22, _toDisplayString(_ctx.$t('message.SHIPPING_ADDRESS')), 1),
                  _createVNode("ul", _hoisted_23, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.CUSTOMER_NAME')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_shipping_address?.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.CITY')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_shipping_address?.city), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.COUNTRY')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_shipping_address?.country?.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.POSTAL_CODE')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_shipping_address?.postal_code), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ADDRESS')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_shipping_address?.address_1), 1)
                    ]),
                    (_ctx.orders?.order_shipping_address?.address_2)
                      ? (_openBlock(), _createBlock("li", _hoisted_24, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ADDRESSES')) + " 2", 1),
                          _createVNode("span", null, _toDisplayString(_ctx.orders.order_shipping_address.address_2), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orders?.order_shipping_address?.phone_number)
                      ? (_openBlock(), _createBlock("li", _hoisted_25, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ACCOUNT_PHONE_NUMBER')), 1),
                          _createVNode("span", null, _toDisplayString(_ctx.orders.order_shipping_address.phone_number), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_26, [
          (_ctx.orders?.order_billing_address)
            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, [
                  _createVNode(_component_InnerLoader, {
                    loading: _ctx.loader,
                    innerLoading: true
                  }, null, 8, ["loading"]),
                  _createVNode("header", _hoisted_29, _toDisplayString(_ctx.$t('message.BILLING_ADDRESS')), 1),
                  _createVNode("ul", _hoisted_30, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.CUSTOMER_NAME')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_billing_address?.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.CITY')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_billing_address?.city), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.COUNTRY')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_billing_address?.country?.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.POSTAL_CODE')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_billing_address?.postal_code), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ADDRESS')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_billing_address?.address_1), 1)
                    ]),
                    (_ctx.orders?.order_billing_address?.address_2)
                      ? (_openBlock(), _createBlock("li", _hoisted_31, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ADDRESSES')) + " 2", 1),
                          _createVNode("span", null, _toDisplayString(_ctx.orders.order_billing_address?.address_2), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orders?.order_billing_address?.phone_number)
                      ? (_openBlock(), _createBlock("li", _hoisted_32, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ACCOUNT_PHONE_NUMBER')), 1),
                          _createVNode("span", null, _toDisplayString(_ctx.orders.order_billing_address.phone_number), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_33, [
        _createVNode("div", _hoisted_34, [
          _createVNode("div", _hoisted_35, [
            (_ctx.customer)
              ? (_openBlock(), _createBlock("div", _hoisted_36, [
                  _createVNode("header", _hoisted_37, _toDisplayString(_ctx.$t('message.CUSTOMER_NAME')), 1),
                  _createVNode("div", _hoisted_38, [
                    _createVNode("div", _hoisted_39, [
                      _createVNode("div", {
                        class: "name-avatar",
                        style: 'background:' + _ctx.companyLogo(_ctx.customer?.user?.name)?.color
                      }, _toDisplayString(_ctx.companyLogo(_ctx.customer?.user?.name)?.name), 5),
                      _createVNode("h3", null, [
                        _createTextVNode(_toDisplayString(_ctx.customer?.user?.name) + " ", 1),
                        _createVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('message.ORDER_ID')) + " # " + _toDisplayString(_ctx.orders?.id), 1),
                        (_ctx.customer?.parent)
                          ? (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('message.MANAGER_OF')) + " : " + _toDisplayString(_ctx.customer?.parent?.name), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.customer?.user?.roles == 'customer')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "view-all-details btn btn-custom fs-7",
                          to: {
                                    name: 'customer_detail',
                                    params: { uuid: _ctx.customer?.uuid }
                                },
                          onClick: _ctx.clearPageHistory
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.DETAILS')), 1)
                          ]),
                          _: 1
                        }, 8, ["to", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_42, [
                  _createVNode("header", _hoisted_43, _toDisplayString(_ctx.$t('message.CUSTOMER_NAME')), 1),
                  _createVNode("div", _hoisted_44, [
                    _createVNode("div", _hoisted_45, [
                      _createVNode("div", {
                        class: "name-avatar",
                        style: 'background:' + _ctx.companyLogo(_ctx.orders?.name)?.color
                      }, _toDisplayString(_ctx.companyLogo(_ctx.orders?.name)?.name), 5),
                      _createVNode("h3", null, [
                        _createTextVNode(_toDisplayString(_ctx.orders?.name) + " ", 1),
                        _createVNode("span", _hoisted_46, "Order ID # " + _toDisplayString(_ctx.orders?.id), 1)
                      ])
                    ])
                  ])
                ])),
            (_ctx.customer)
              ? (_openBlock(), _createBlock("div", _hoisted_47, [
                  _createVNode("header", _hoisted_48, _toDisplayString(_ctx.$t('message.CUSTOMER_INFORMATION')), 1),
                  _createVNode("ul", _hoisted_49, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.EMAIL')), 1),
                      _createVNode(_component_el_tooltip, {
                        class: "item",
                        effect: "dark",
                        content: _ctx.customer?.user?.email,
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.customer?.user?.email), 1)
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.PHONE_NUMBER')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.customer?.phone_number), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.CUSTOMER_GROUP')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.customer?.customer_group?.name), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.STATUS')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.customer?.user?.status == 1 ? _ctx.$t('message.ACTIVE') : _ctx.$t('message.INACTIVE')), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ORDER_CREATED_AT')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders.created_at), 1)
                    ])
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_50, [
                  _createVNode("header", _hoisted_51, _toDisplayString(_ctx.$t('message.CUSTOMER_INFORMATION')), 1),
                  _createVNode("ul", _hoisted_52, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.EMAIL')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders.email), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.PHONE_NUMBER')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders.order_shipping_address?.phone_number), 1)
                    ])
                  ])
                ])),
            (_ctx.orders?.order_subscription_history?.order_subscription_id || _ctx.orders?.order_discount?.discount_id)
              ? (_openBlock(), _createBlock("div", _hoisted_53, [
                  _createVNode("header", _hoisted_54, _toDisplayString(_ctx.$t('message.ORDER_INFORMATION')), 1),
                  (Object.values(_ctx.orderTotals).length != 0)
                    ? (_openBlock(), _createBlock("ul", _hoisted_55, [
                        (_ctx.orders?.order_subscription_history?.order_subscription_id)
                          ? (_openBlock(), _createBlock("li", _hoisted_56, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ORDER')), 1),
                              _createVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('message.SUBSCRIPTIONS_ORDERS')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.orders?.order_discount?.discount_id)
                          ? (_openBlock(), _createBlock("li", _hoisted_58, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('message.DISCOUNT_CODE')), 1),
                              _createVNode("span", null, _toDisplayString(_ctx.orders?.order_discount?.discount?.code), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_59, [
              _createVNode("header", _hoisted_60, _toDisplayString(_ctx.$t('message.ORDER_PAYMENT_INFORMATION')), 1),
              (Object.values(_ctx.orderTotals).length != 0)
                ? (_openBlock(), _createBlock("ul", _hoisted_61, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.PAYMENT_METHOD')), 1),
                      (_ctx.orders.order_payment)
                        ? (_openBlock(), _createBlock("span", _hoisted_62, _toDisplayString(JSON.parse(_ctx.orders?.order_payment?.payment_method?.name)[_ctx.system_locale]?.name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.TRANSACTION_ID')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orders?.order_payment?.transaction_id), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_63, [
              _createVNode("header", _hoisted_64, _toDisplayString(_ctx.$t('message.EXTERNAL_ORDER_STATUS')), 1),
              _createVNode("ul", _hoisted_65, [
                _createVNode("li", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ECONOMIC_STATUS')), 1),
                  (_ctx.isOrderSentToBc)
                    ? (_openBlock(), _createBlock("span", _hoisted_66, _toDisplayString(_ctx.$t('message.SENT')), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_67, [
                        _createTextVNode(_toDisplayString(_ctx.$t('message.NOT_SENT')) + " ", 1),
                        _createVNode("span", {
                          class: ["ml-2", _ctx.asideTheme === 'dark' ? 'resend-msg-dark' : 'resend-msg-light'],
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resendOrderEconomic(_ctx.orders?.id)))
                        }, _toDisplayString(_ctx.i18n.t('message.RESEND')), 3)
                      ]))
                ]),
                (_ctx.isOrderSentToBc)
                  ? (_openBlock(), _createBlock("li", _hoisted_68, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.ECONOMIC_NUMBER')), 1),
                      _createVNode(_component_el_tooltip, {
                        class: "item",
                        effect: "dark",
                        content: _ctx.orders?.economic_order_number,
                        placement: "top"
                      }, {
                        default: _withId(() => [
                          _createVNode("span", null, _toDisplayString(_ctx.orders?.economic_order_number), 1)
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.orders?.order_shipment)
              ? (_openBlock(), _createBlock("div", _hoisted_69, [
                  _createVNode("header", _hoisted_70, [
                    _createVNode("div", _hoisted_71, _toDisplayString(_ctx.$t('message.SHIPMENT_ORDER_STATUS')), 1),
                    (_ctx.asideTheme === 'light')
                      ? (_openBlock(), _createBlock("div", _hoisted_72, [
                          _hoisted_73
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_74, [
                          _hoisted_75
                        ]))
                  ]),
                  _createVNode(_component_el_steps, {
                    direction: "vertical",
                    active: 
                                _ctx.orders.order_shipment?.is_fulfilled == 0
                                    ? 0
                                    : _ctx.orders.order_shipment?.is_fulfilled == 1 && _ctx.orders.order_shipment?.tracking_id == null
                                    ? 1
                                    : _ctx.orders.order_shipment?.is_fulfilled == 1 && _ctx.orders.order_shipment?.tracking_id != null && _ctx.orders.order_shipment?.is_notified == 0
                                    ? 2
                                    : _ctx.orders.order_shipment?.is_fulfilled == 1 && _ctx.orders.order_shipment?.tracking_id != null && _ctx.orders.order_shipment?.is_notified == 1
                                    ? 3
                                    : ''
                            ,
                    class: "order-status-steps shipment-summary-status",
                    "finish-status": "success"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_step, {
                        title: 
                                    _ctx.orders.order_shipment?.is_fulfilled == 0
                                        ? _ctx.i18n.t('message.ORDER_HAS_NOT_BEEN_FULFILLED')
                                        : _ctx.orders.order_shipment?.is_fulfilled == 1
                                        ? _ctx.i18n.t('message.ORDER_HAS_BEEN_FULFILLED')
                                        : ''
                                
                      }, null, 8, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.i18n.t('message.TRACKING_ID') + ' : '
                      }, _createSlots({ _: 2 }, [
                        (_ctx.orders.order_shipment?.tracking_id != null)
                          ? {
                              name: "title",
                              fn: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.i18n.t('message.TRACKING_ID')) + " : ", 1),
                                _createVNode("a", {
                                  href: _ctx.orders.order_shipment?.url,
                                  target: "_blank"
                                }, _toDisplayString(_ctx.orders.order_shipment?.tracking_id), 9, ["href"])
                              ])
                            }
                          : {
                              name: "title",
                              fn: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.i18n.t('message.TRACKING_ID')) + " : " + _toDisplayString('N/A'), 1)
                              ])
                            }
                      ]), 1032, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.i18n.t('message.MESSAGE_SENT')
                      }, _createSlots({ _: 2 }, [
                        (_ctx.orders.order_shipment?.is_notified == 0)
                          ? {
                              name: "title",
                              fn: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.i18n.t('message.MESSAGE_NOT_SENT')), 1)
                              ])
                            }
                          : {
                              name: "title",
                              fn: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.i18n.t('message.MESSAGE_SENT')) + " ", 1),
                                _createVNode("span", {
                                  class: "resed-msg",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resendMsg(_ctx.orders?.id)))
                                }, " : " + _toDisplayString(_ctx.i18n.t('message.RESEND')), 1)
                              ])
                            }
                      ]), 1032, ["title"])
                    ]),
                    _: 1
                  }, 8, ["active"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_76, [
              _createVNode("header", _hoisted_77, _toDisplayString(_ctx.$t('message.ORDER_SUMMARY')), 1),
              (Object.values(_ctx.orderTotals).length != 0)
                ? (_openBlock(), _createBlock("ul", _hoisted_78, [
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('message.SUB_TOTAL')), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orderTotals?.sub_total?.value), 1)
                    ]),
                    _createVNode("li", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.orderTotals?.shipping?.title), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orderTotals?.shipping?.value), 1)
                    ]),
                    (_ctx.orders.site.prices_with_tax == 0 && _ctx.orderTotals?.discount)
                      ? (_openBlock(), _createBlock("li", _hoisted_79, [
                          _createVNode("strong", null, _toDisplayString(_ctx.orderTotals?.discount?.title), 1),
                          _createVNode("span", null, "-" + _toDisplayString(_ctx.orders?.discount_price_without_tax), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orders.site.prices_with_tax == 1 && _ctx.orderTotals?.discount)
                      ? (_openBlock(), _createBlock("li", _hoisted_80, [
                          _createVNode("strong", null, _toDisplayString(_ctx.orderTotals?.discount?.title), 1),
                          _createVNode("span", null, "-" + _toDisplayString(_ctx.orders?.discount_price_with_tax), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orders.site.prices_with_tax == 0)
                      ? (_openBlock(), _createBlock("li", _hoisted_81, [
                          _createVNode("strong", null, _toDisplayString(_ctx.orderTotals?.tax?.title), 1),
                          _createVNode("span", null, _toDisplayString(_ctx.orderTotals?.tax?.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("li", _hoisted_82, [
                      _createVNode("strong", null, _toDisplayString(_ctx.orderTotals?.total?.title), 1),
                      _createVNode("span", null, _toDisplayString(_ctx.orderTotals?.total?.value), 1)
                    ]),
                    (_ctx.orders.site.prices_with_tax == 1)
                      ? (_openBlock(), _createBlock("li", _hoisted_83, [
                          _createVNode("strong", null, _toDisplayString(_ctx.orderTotals?.tax?.title), 1),
                          _createVNode("span", null, _toDisplayString(_ctx.orderTotals?.tax?.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.orderNotesList.length)
              ? (_openBlock(), _createBlock("div", _hoisted_84, [
                  _createVNode("ul", _hoisted_85, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orderNotesList, (orderNote, index) => {
                      return (_openBlock(), _createBlock("li", { key: index }, [
                        _createVNode("strong", null, _toDisplayString(orderNote.label), 1),
                        _createVNode(_component_el_tooltip, {
                          class: "item",
                          effect: "dark",
                          content: orderNote.value,
                          placement: "top",
                          disabled: !_ctx.noteTruncated[index]
                        }, {
                          default: _withId(() => [
                            _createVNode("span", {
                              ref: el => _ctx.setNoteValueRef(el, index)
                            }, _toDisplayString(orderNote.value), 513)
                          ]),
                          _: 2
                        }, 1032, ["content", "disabled"])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_86, [
              _createVNode("header", _hoisted_87, _toDisplayString(_ctx.$t('message.ORDER_STATUS')), 1),
              _createVNode(_component_Select, {
                name: "order_status",
                target: "order_status",
                onChange: _ctx.updateStatus,
                placeholder: `${_ctx.$t('message.ORDER_STATUS')}`,
                order_status: _ctx.order_status,
                "onUpdate:order_status": _cache[3] || (_cache[3] = ($event: any) => (_ctx.order_status = $event)),
                selectData: _ctx.statusList,
                clearable: false,
                callEmit: true,
                value: _ctx.orders?.order_status?.status ? JSON.parse(_ctx.orders?.order_status?.status)[_ctx.system_locale]?.name : null,
                disabled: _ctx.orders?.order_status_id == 3 || _ctx.orders?.order_status_id == 6
              }, null, 8, ["onChange", "placeholder", "order_status", "selectData", "value", "disabled"])
            ]),
            (!_ctx.orders?.economic_order_number && _ctx.bcErrorMessage)
              ? (_openBlock(), _createBlock("div", _hoisted_88, [
                  _createVNode("header", _hoisted_89, _toDisplayString(_ctx.$t('message.BUSINESS_CENTRAL_ERROR')), 1),
                  _createVNode("div", _hoisted_90, _toDisplayString(_ctx.bcErrorMessage), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
})